import React from "react";
import "./style.css";
import back_icon from "../../assets/icons/arrow-left.svg";
import refresh_icon from "../../assets/icons/rotate-ccw.svg";

export default function Navigator({ stateAndDispatch }) {
  const {
    state: { step },
    dispatch,
  } = stateAndDispatch;

  return (
    <div className="navigation-buttons">
      <button
        onClick={() => {
          dispatch({
            type: "SWITCH_STEP",
            to: step - 1,
          });
        }}
        disabled={step === 0}
      >
        <img src={back_icon} />
      </button>
      <button onClick={() => window.location.reload()}>
        <img src={refresh_icon} />
      </button>
    </div>
  );
}
